import { FC, SVGProps } from 'react'

export const Edit: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.9896 4.86637C17.478 4.37788 18.2647 4.37788 18.7532 4.86637C19.2416 5.35485 19.2416 6.14149 18.7532 6.62997L7.13227 18.2509L4.78079 18.8387L5.36866 16.4873L16.9896 4.86637ZM19.8138 3.80571C18.7395 2.73143 17.0032 2.73143 15.9289 3.80571L4.16111 15.5735C4.06499 15.6696 3.9968 15.79 3.96383 15.9219L3.02241 19.6876C2.95851 19.9432 3.0334 20.2136 3.21969 20.3998C3.40597 20.5861 3.67634 20.661 3.93192 20.5971L7.69761 19.6557C7.82948 19.6227 7.94992 19.5545 8.04604 19.4584L19.8138 7.69063C20.8881 6.61636 20.8881 4.87998 19.8138 3.80571ZM12.2228 19.1195C11.8086 19.1195 11.4728 19.4553 11.4728 19.8695C11.4728 20.2837 11.8086 20.6195 12.2228 20.6195H20.6956C21.1098 20.6195 21.4456 20.2837 21.4456 19.8695C21.4456 19.4553 21.1098 19.1195 20.6956 19.1195H12.2228Z"
			fill="currentColor"
		/>
	</svg>
)
